export default "__VITE_ASSET__CkFOh96p__"